import { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';
export const getUnreadConversationsCount = async twilioClient => {
  let twilioList = await twilioClient.getSubscribedConversations();
  let conversations = twilioList.items;
  let unreadConversations = 0;
  let rawUnreadConvos = [];
  while (twilioList.hasNextPage) {
    twilioList = await twilioList.nextPage();
    conversations = [...conversations, ...twilioList.items];
  }
  conversations.forEach(conversation => {
    var _conversation$state, _conversation$lastMes;
    if ((conversation === null || conversation === void 0 || (_conversation$state = conversation.state) === null || _conversation$state === void 0 ? void 0 : _conversation$state.current) === "active" && conversation !== null && conversation !== void 0 && conversation.lastMessage && ((_conversation$lastMes = conversation.lastMessage) === null || _conversation$lastMes === void 0 ? void 0 : _conversation$lastMes.index) !== conversation.lastReadMessageIndex) {
      unreadConversations++;
      rawUnreadConvos.push(conversation);
    }
  });
  return unreadConversations;
};
export const useUnreadConversationsCount = (twilioClient, messageCenterLogger) => {
  const [unreadConversations, setUnreadConversations] = useState(null);
  const refreshUnreadConversationsCount = useCallback(debounce(async () => {
    try {
      const notifications = await getUnreadConversationsCount(twilioClient);
      setUnreadConversations(notifications);
    } catch (error) {
      // Gracefully ignore.
      // This is caused by network instability / lack of connection speed.
      if (error.name === 'SyncError' && error.message.indexOf('Twilsock: request timeout') === 0) {
        if (messageCenterLogger) {
          messageCenterLogger.error('Twilsock: request timeout;', {}, error);
        }
      }
    }
  }));
  useEffect(() => {
    if (twilioClient) {
      twilioClient.on('conversationAdded', refreshUnreadConversationsCount);
      twilioClient.on('initialized', refreshUnreadConversationsCount);
      twilioClient.on('conversationJoined', refreshUnreadConversationsCount);
      twilioClient.on('messageAdded', refreshUnreadConversationsCount);
      twilioClient.on('conversationUpdated', refreshUnreadConversationsCount);
    }
    return () => {
      if (twilioClient) {
        twilioClient.off('conversationAdded', refreshUnreadConversationsCount);
        twilioClient.off('initialized', refreshUnreadConversationsCount);
        twilioClient.off('conversationJoined', refreshUnreadConversationsCount);
        twilioClient.off('messageAdded', refreshUnreadConversationsCount);
        twilioClient.off('conversationUpdated', refreshUnreadConversationsCount);
      }
    };
  }, [twilioClient]);
  return unreadConversations;
};
//# sourceMappingURL=useUnreadNotificationsCount.js.map